<template>
    <button v-bind="attrs" class="flex items-center" @click="click">
        <div v-if="loading" class="spinner mr-2"/>
        <slot/>
    </button>
</template>

<script>
    export default {
        props: {
            loading: Boolean,
        },
        methods: {
            click() {
                this.$emit('click')
            }
        },
        computed: {
            attrs(){
                return  {
                    disabled: this.loading,
                    ...this.$attrs
                }
            }
        }
    }
</script>